export default __webpack_public_path__ + "static/media/welcomeSchoolyard.38b540cf.svg";